import { events } from '@wh/quick-deposit';
import { publish, subscribe } from './patched-message-bus';
import { DEPOSIT, QUICK_DEPOSIT } from './constants';
import { commandClose } from './message-bus-helpers/commandClose';
import { commandOpen } from './message-bus-helpers/commandOpen';
import { onEventClosed } from './message-bus-helpers/eventClosed';
import { onEventFailed } from './message-bus-helpers/eventFailed';
import { onEventOpened } from './message-bus-helpers/eventOpened';
import { onEventRequested } from './message-bus-helpers/eventRequested';

// 'modal_clos' is sent on mobile, 'modal_close' is sent on desktop (there is no typo)
const OPENBET_MODAL_CLOSE_EVENTS = ['modal_clos', 'modal_close', 'modal_close_without_reload'];

const listenToModalClose = ({ data }) => {
  if (OPENBET_MODAL_CLOSE_EVENTS.includes(data)) {
    publish(commandClose({ type: DEPOSIT }));
  }
};

export const depositWorkflow = (options = {}) => {
  const useGlobal = typeof options.disableQuickDeposit !== 'undefined';
  subscribe(
    onEventRequested((eventData = {}) => {
      const { closeOnSuccess, eventSource, submitTextKey, pmtSource } = eventData;
      const disableQuickDeposit = useGlobal
        ? options.disableQuickDeposit
        : eventData.disableQuickDeposit;
      publish(
        commandOpen({
          closeOnSuccess,
          eventSource,
          submitTextKey,
          type: disableQuickDeposit ? DEPOSIT : QUICK_DEPOSIT,
          pmtSource,
        }),
      );
    }),
  );

  const switchFromQuickDepositToDeposit = () => {
    publish(commandClose({ type: QUICK_DEPOSIT }));
    publish(commandOpen({ type: DEPOSIT }));
  };

  const handleQuickDepositFailedEvent = ({ code }) => {
    if (code !== 'PAYMENT') {
      switchFromQuickDepositToDeposit();
    }
  };

  subscribe(events.MESSAGE_PUB_QD_OPEN_DEPOSIT, switchFromQuickDepositToDeposit);
  subscribe(onEventFailed(handleQuickDepositFailedEvent));

  subscribe(
    onEventOpened(() => {
      window.addEventListener('message', listenToModalClose, false);
    }),
  );
  subscribe(
    onEventClosed(() => {
      window.removeEventListener('message', listenToModalClose, false);
    }),
  );
};
